import { render, staticRenderFns } from "./PlaylistDetails.vue?vue&type=template&id=640c3d46&"
import script from "./PlaylistDetails.vue?vue&type=script&lang=js&"
export * from "./PlaylistDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports